import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import AccountCheckIcon from "@iconify/icons-mdi/account-check";
import { Icon } from "@iconify/react";

interface Uploader {
  name: string;
  contract: string;
}

interface MyDocumentsUploadersProps {
  uploadersData: Uploader[];
  loading: boolean;
}

export const MyDocumentsUploaders = ({
  uploadersData,
  loading,
}: MyDocumentsUploadersProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  if (uploadersData?.length === 0 && !loading) {
    return (
      <Box style={{ color: theme.palette.primary.main, padding: "16px 0px" }}>
        {t("MY_DOCUMENTS_MISSING_UPLOADERS")}
      </Box>
    );
  }

  return (
    <>
      {uploadersData?.map((item, index) => {
        return (
          <Box
            key={`my-documents-uploader-${index}`}
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Icon icon={AccountCheckIcon} height="24px" />
            <Box width="10px" />
            <Box paddingBottom="4px">{item.name}</Box>
          </Box>
        );
      })}
    </>
  );
};

export default MyDocumentsUploaders;
